@if (config?.partnerPage?.isPublished) {
  <article>
    <commerce-partner-page-info-section
      data-cy="partner-page-expandable-info"
      [partnerName]="config.partnerPage.name || ''"
      [partnerTitle]="config.partnerPage.title || ''"
      [partnerDescription]="config.partnerPage.descriptionHtml || ''"
      [logo]="logo"
      [highlightItems]="highlightItems"
      [checklistGroups]="config.partnerPage.capabilitiesChecklists || []"
      [socialMediaLinks]="socialMediaItems"
      [availability]="config.partnerPage.availability || []">
    </commerce-partner-page-info-section>
    <section class="alternative-section-highlight">
      @if (productCardItems.length > 0 || showcaseCaseStories) {
        <sirius-spacer></sirius-spacer>
      }
      @if (productCardItems.length > 0) {
        <div class="products-container">
          <sirius-card-slider
            data-cy="card-slider"
            [title]="'page.partner.ourProducts' | translate"
            [items]="productCardItems">
          </sirius-card-slider>
          <sirius-spacer></sirius-spacer>
        </div>
      }
      @if (showcaseCaseStories) {
        <commerce-showcase-case-stories [caseStoryItems]="showcaseCaseStories" data-cy="case-stories">
        </commerce-showcase-case-stories>
        <sirius-spacer></sirius-spacer>
      }
    </section>
  </article>
} @else {
  <sirius-grid>
    <header class="header sir-text-style-title-l-default" data-cy="no-partner-data-header">
      <h2>{{ config?.partnerPage?.name }}</h2>
    </header>
  </sirius-grid>
  @if (config) {
    <sirius-card-catalogue
      [items]="productCardItems"
      [filters]="filters"
      [paging]="paging"
      [sorting]="sorting"
      [dataSource]="dataSource">
    </sirius-card-catalogue>
  }
}

